// store/thunks/auth/verifyRecoveryTwoFactorThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const verifyRecoveryTwoFactorThunk = createAppAsyncThunk<
  undefined,
  { code: string },
  { rejectValue: { message: string } }
>(
  'auth/verifyRecoveryTwoFactorThunk',
  async({ code }, { getState, extra: { authService }, rejectWithValue }) => {
    const state = getState();
    const recoveryToken = state.auth.recoveryToken;

    if (recoveryToken === undefined || (typeof recoveryToken !== 'string')) {
      return rejectWithValue({ message: 'Missing recovery token' });
    }

    try {
      await authService.verifyRecoveryTwoFactor({ recoveryToken, code, method: 'sms' });
      return undefined;
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to verify SMS code';
      return rejectWithValue({ message });
    }
  }
);
